import React, { useContext, useEffect, useState } from "react";
import { Button, Col, Row, Typography, Breadcrumb } from "antd";
import { Link, useNavigate } from "react-router-dom";

import { translate } from "../../../locale";
import ContactsTable from "../../../components/Tables/ContactsTable";
import InviteContact from "../../../components/Modals/InviteContact";
import { AdminContext } from "../../../providers/AdminContext";
import UserServices from "../../../services/UserServices";

const { Title } = Typography;

const Contacts = () => {
  const [modalVisible, setModalVisible] = useState(false);
  const [reloadTable, setReloadTable] = useState(null);
  const { user } = useContext(AdminContext);
  const [hasPermissions, setHasPermissions] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    if (user) {
      setHasPermissions(
        user.user.rol === "eira-super-admin" ||
          user.user.rol === "eira-company-admin"
      );
      loadProfile();
    }
  }, [user]);

  const loadProfile = async () => {
    try {
      const response = await UserServices.getProfile();
      const _user = response.data.my_contact_info.user;

      const canInvite = response.data.can_invite
        ? response.data.can_invite.filter((i) => i.can_invite === true)
        : [];
      setHasPermissions(
        _user.rol === "eira-super-admin" ||
          _user.rol === "eira-company-admin" ||
          (_user.rol === "eira-professional" && canInvite.length > 0)
      );
    } catch (error) {
      console.log(error);
    }
  };

  const handleModalCancel = () => {
    setModalVisible(false);
  };

  const handleModalComplete = () => {
    // update user list
    setModalVisible(false);
    setReloadTable((v) => v + 1);
  };

  const handleSendInvittion = () => {
    setModalVisible(true);
  };

  const handlePendingInvitations = () => {
    navigate("/admin/contacts/pendings");
  };

  return (
    <div className="flex flex-col min-h-full w-screen max-w-7xl pb-16 my-10 mx-0 md:mx-10 px-4 md:px-0">
      <Row>
        <Col className="gutter-row" span="24">
          <Breadcrumb>
            <Breadcrumb.Item>
              <Link to="/admin">{translate("Inicio")}</Link>
            </Breadcrumb.Item>
            <Breadcrumb.Item>{translate("Contactos")}</Breadcrumb.Item>
          </Breadcrumb>
        </Col>
        <Col span="24" className="my-4">
          <Title level={2} className="text-center !text-lg md:!text-3xl">
            {translate("Contactos")}
          </Title>
        </Col>

        <Col className="gutter-row" span="12">
          <div className="text-start">
            <Button
              type="primary"
              className="bg-white text-custom_darkgray border-1 border-custom_primary hover:bg-custom_primary hover:text-white hover:border-custom_primary"
              onClick={handleSendInvittion}
              disabled={!hasPermissions}
              title={
                !hasPermissions
                  ? "No tienes permisos para enviar invitaciones"
                  : ""
              }
            >
              {translate("Enviar solicitud")}
            </Button>
            <InviteContact
              data={{ emails: "", user: user }}
              visible={modalVisible}
              onCancel={handleModalCancel}
              onComplete={handleModalComplete}
            />
          </div>
        </Col>

        <Col className="gutter-row" span="12">
          <div className="text-end">
            <Button
              type="primary"
              className="bg-white text-custom_darkgray border-1 border-custom_primary hover:bg-custom_primary hover:text-white hover:border-custom_primary"
              onClick={handlePendingInvitations}
            >
              {translate("Invitaciones enviadas")}
            </Button>
          </div>
        </Col>

        <Col span="24" className="mt-6">
          <ContactsTable reload={reloadTable} />
        </Col>
      </Row>
    </div>
  );
};

export default Contacts;
